import { mapActions, mapState } from 'pinia';
import { useUserStore, usePageStore } from '@/store';
import util from '../common/util';
import { unformats } from '../common/format';
import { getFromDetailPageParam } from '@/common/business/agent-detail';
import questionnaire from '../components/questionnaire';
import vForm from '../components/v-form.vue';
import vInput from '../components/v-input.vue';
import { state as regState } from '@/components/sign-log/register-track';
import AutoRegister from '../common/autoRegister';
import { openLoginHideOtherPop } from '@/components/sign-log';
import checkbox from '@/components/checkbox';
import { loginOrRegister } from '@/components/sign-log/socialstudio-lead-tag.js';
import { leadTypes, isBuyer, isSeller, isAgent } from '@/common/const';
import popMgr from '@/components/global/popMgr';
import { globalRegisterParamsFormat } from '@/common/register/params-format.js'
import agentLeadDialog from '@/components/sign-log/agent-lead-dialog.vue'
export default {
    data: function() {
        return {
            registerErrorShow: false,
            registerErrorMsg: '',
            data: {},
            isRegisterAgentLead: false
        };
    },
    mounted() {
        this.autoRegisterInstance = AutoRegister.getInstance(
            this,
            this.hasEmailLead
        );
        this.autoRegisterInstance.start();
    },
    beforeUnmount() {
        this.autoRegisterInstance && this.autoRegisterInstance.destroy();
    },
    computed: {
        ...mapState(usePageStore, ['page', 'hasEmailLead']),
        ...mapState(useUserStore, ['user']),
        ignoreBuyerPhone({ page }) {
            return !!(page.registration && page.registration.ignoreBuyerPhone);
        },
        ignoreSellerPhone({ page }) {
            return !!(page.registration && page.registration.ignoreSellerPhone);
        },
        facebook({ page }) {
            return page.facebook;
        },
        google({ page }) {
            return page.google;
        },
        phoneDesciption({ page }) {
            return page.phoneDesciption || '';
        },
        toastMsg({ page }) {
            return (
                page.registration?.toast || this.$t('common:register.toastMsg')
            );
        },
        role({ page, registerRole }) {
            // registerRole from  md-form custom  set
            return registerRole || page.registerUserType || leadTypes.Buyer;
        },
        toastDuration({ page }) {
            return (
                (page.registration && page.registration.toastDuration) || 1000
            );
        },
        inquiry() {
            if (this.registerLogin) {
                return false;
            }
            // todo leadtype
            let inquiry = true;
            if (isAgent(this.role) || this.isRegisterAgentLead) {
                inquiry  = false;
            } else if (isBuyer(this.role)) {
                inquiry = !!(
                    this.page.questionNaire && this.page.questionNaire.inquiry
                );
            } else if (isSeller(this.role)) {
                inquiry = !!(
                    this.page.questionNaire &&
                    this.page.questionNaire.inquirySeller
                );
            } else {
                inquiry = false;
            }
            return inquiry;
        },
        hasLenderCheckBox() {
            return (
                (isBuyer(this.role)) &&
                this.page.hasLenderCheckBox
            );
        },
        ignorPhone() {
            if (isBuyer(this.role) && !isSeller(this.role)) {
                return this.ignoreBuyerPhone;
            } else {
                return this.ignoreSellerPhone;
            }
        }
    },
    methods: {
        ...mapActions(useUserStore, ['login']),
        ...mapActions(usePageStore, ['updateSocialTagType']),
        onRegisterCallback(callback, isToast) {
            let data = {
                ... this.user,
                isRegisterAgentLead: this.isRegisterAgentLead || isAgent(this.user)
            }
            if (
                util.call(callback, null, data, this.inquiry) !== false &&
                isToast &&
                this.toastMsg
            ) {
                util.toast(this.toastMsg);
            }
            this.submitDisabled = false;
        },
        onSuccessCallback(callback, isToast) {
            let data = {
                ... this.data,
                isRegisterAgentLead: this.isRegisterAgentLead || isAgent(this.role)
            }
            if (
                util.call(callback, null, data, this.inquiry) !== false &&
                isToast &&
                this.toastMsg
            ) {
                util.toast(this.toastMsg, this.toastDuration);
            }
            this.submitDisabled = false;
        },
        registerNext() {
            // The logic of the reference is supplemented and perfected
            this.onSuccessCallback();
        },
        showQuestionnaire(options = {}) {
            const type = isSeller(this.role) ? 1 : 0;
            questionnaire.open({ options, type, globalData: this.page });
        },
        onregisterFail(msg) {
            this.registerErrorShow = true;
            this.registerErrorMsg = msg;
            const vm = this;
            const needSignIn =
                msg === 'The email has been registered, please sign in.';
            util.timeout({
                handler: () => {
                    this.registerErrorShow = false;
                    this.registerErrorMsg = '';
                    needSignIn &&
                        openLoginHideOtherPop(
                            vm.options,
                            this.step1Data.email || this.step1Data.account || ''
                        );
                },
                delay: 3000,
                unique: true
            });
        },
        formatData(data, formatFun) {
            data.phoneNumber = data.phoneNumber || data.phone || '';
            data.account = data.account || data.email || '';
            data.fullname = data.fullname || data.fullName || '';
            data.pageUrl = window.location.href;
            // listingId and isSoldListing  rear end GlobalData Give
            if (this.page.listingId !== undefined) {
                data.listingId = this.page.listingId;
            }
            if (this.page.isSoldListing !== undefined) {
                data.sold = this.page.isSoldListing;
            }
            let mName = data.fullname.match(/([\S]+)(?: +([\S\s]+))?/) || [
                null,
                ''
            ];
            data.firstName = data.firstName || mName[1] || '';
            data.lastName = data.lastName || mName[2] || '';
            if (!data.fullname) {
                if (data.prefix) {
                    data.firstName = data.prefix + ' ' + data.firstName;
                    delete data.prefix;
                }
                if (data.suffix) {
                    data.lastName = data.lastName + ' ' + data.suffix;
                    delete data.suffix;
                }
                data.fullname = data.firstName + ' ' + data.lastName;
            }

            data.roles = this.role;
            data.phoneNumber = unformats.number(data.phoneNumber || '');

            data.canAssignToLender = isBuyer(this.role) && !isSeller(this.role);
            let campaignId = util.getQueryField('campaignId');
            if (campaignId) {
                data.campaignId = campaignId;
            }
            util.call(formatFun, null, data);
            
            // 直接获取并合并 disclaimer 参数
            if (this.disclaimerCustomParams) {
                Object.assign(data, JSON.parse(JSON.stringify(this.disclaimerCustomParams)));
            }
            
            this.data = data;
        },
        hasRegisterAgentLead(account) {
            return this.axiosIns.get(`/api-site/check-agent-lead?account=${account}&t=${Date.now()}`).then(res => {
                return res?.data?.agentLead;
            }).catch(err => {
                console.log(err);
                return false;
            })
        },
        // https://jira.chimeinc.com/browse/SITE-12187
        // sell my house  page AddHouseInfo  and  register  The interface is merged into  /api-site/sell/add-house
        //  The registration interface in other places remains unchanged
        // isAuto Flags automatically registered for background timing
        async submitRegisterInfo(virtualHouseInfo, isAuto) {
            let params = {};
            let url = '';
            let customParams = this.disclaimerCustomParams || {};
            await globalRegisterParamsFormat(customParams);
            let { registerLogin } = this;
            this.isRegisterAgentLead = await this.hasRegisterAgentLead(this.data.account);
            let additionParams = {
                finishLoginStatus: !registerLogin && !isAgent(this.role),
                ...getFromDetailPageParam()
            };
            virtualHouseInfo = virtualHouseInfo || this.options?.addHouseInfo; //  need to merge
            if (this.isRegisterAgentLead) {
                if (this.data.msg || this.data.question) {
                    params = {
                        ...this.data,
                        emailAddress: this.data.account
                    }
                    url = '/api-site/leaveMsg'
                    popMgr.create(agentLeadDialog, {
                        isRegister: true,
                    });
                } else {
                    popMgr.create(agentLeadDialog, {
                        isRegister: true,
                    });
                    return Promise.resolve({});
                }
            } else if (virtualHouseInfo && !isAuto) {
                url = `/api-site${
                    registerLogin ? '/unrestricted' : ''
                }/sell/add-house`;
                let tagIds = this.data.tag || virtualHouseInfo.tagIds || '';
                this.data.tagIds = tagIds;
                virtualHouseInfo.tagIds = tagIds;
                delete this.data.tag;
                params.registerInfo = {
                    ...this.data,
                    ...customParams,
                    ...additionParams
                };
                params.virtualHouseInfo = virtualHouseInfo;
            } else {
                let tag = this.data.tag;
                tag && (this.data.tagIds = tag);
                delete this.data.tag;
                params = { ...this.data };
                let questionFormat = this.options?.questionFormat;
                if (questionFormat) {
                    params.question = questionFormat(params.question);
                }
                if (isAuto) {
                    url = '/api-site/auto/leadRegister';
                    Object.assign(params, customParams, { callOptIn: false, textOptIn: false });
                } else {
                    url = registerLogin ? '/api-site/unrestricted/leadRegister' : '/api-site/leadRegister';
                    Object.assign(params, customParams, additionParams);
                }
            }
            let res = await this.submitRegisterApi(url, params, {
                virtualHouseInfo,
                isAuto
            }, { needCaptchaToken: !registerLogin });
            this.registerLogin && window.siteAppVm.updateChat(null, true);
            return res;
        },
        submitRegisterApi(url, params) {
            // other theme  overwrite this method
            // please do not change the original logic
            return this.axiosIns.post(url, params, { needCaptchaToken: true });
        },
        //  add one option parameter
        // https://jira.chimeinc.com/browse/SITE-12187
        // md-sell-form middle pass option:{virtualHouseInfo:{}}
        //  used to judge   Do you need to  addHouseInfo  and register interface merge
        leadRegister(option, isAuto = false) {
            return this.submitRegisterInfo(
                option && option.virtualHouseInfo,
                isAuto
            )
                .then(res => {
                    if (isAuto) {
                        return res; 
                    }
                    const resData = res?.data;
                    const user = resData?.user;
                    if (resData?.leadAccid && resData?.leadToken) {
                        user.leadAccid = resData.leadAccid;
                        user.leadToken = resData.leadToken;
                    }
                    this.$EventBus.$emit('siteTrack', {
                        ...this.data,
                        gaPopScenario: this.options?.gaPopScenario,
                        trackType: 'register',
                        id: user?.id,
                        teamId: user?.teamId,
                        ele: this.$el
                    });
                    if (this.registerLogin || isAgent(this.role)) {
                        this.registerNext({
                            ... this.data,
                            isRegisterAgentLead: this.isRegisterAgentLead || isAgent(this.role)
                        });
                        return res;
                    }
                    //  Advertising registration do not play questionnaire
                    !this.data?.dynamicRegister &&
                        this.inquiry &&
                        questionnaire.prepare(undefined, this.page);
                    this.login({ user });
                    if (this.page.wordPressSSR && resData?.['0']) {
                        this.setCookies(resData['0']);
                    }
                    this.updateSocialTagType(loginOrRegister.register);
                    //  pass socialstudio users who click in ， Requires marking when logging in
                    // setLeadTag(
                    //     loginOrRegister.register,
                    //     user?.id || '',
                    //     user?.teamId || ''
                    // );
                    // this.submitDisabled = false;
                    this.registerNext(this.data);
                    this.trackGlobalRegisPopup(regState.success);
                })
                .catch(error => {
                    console.error(error);
                    if (isAuto) {
                        return;
                    }
                    this.$EventBus.$emit('siteTrack', {
                        gaPopScenario: this.options?.gaPopScenario,
                        role: this.role,
                        errorData: error,
                        trackType: 'lead-register-fail',
                        ele: this.$el
                    });
                    if (!error.error) {
                        const errorMsg =
                            error.errorInfo ||
                            this.$t('common:register.registerError');
                        this.onregisterFail(errorMsg);
                    } else {
                        const errorMsg =
                            (error.errorInfo &&
                                error.errorInfo.status &&
                                error.errorInfo.status.msg) ||
                            this.$t('common:register.registerError');
                        this.onregisterFail(errorMsg);
                    }
                    this.trackGlobalRegisPopup(regState.fail);
                    // this.submitDisabled = false;
                });
        },
        setCookies(cookies) {
            console.warn('set cookies');
            for (let key in cookies) {
                console.log('set' + key + '=' + cookies[key]);
                util.setCookie(key, cookies[key], 30);
            }
        },
        //  automatic registration
        leadAutoRegister(data, option) {
            this.formatData(data);
            this.submitRegisterInfo(option && option.virtualHouseInfo, true);
        },
        registerSubmit(form, data) {
            console.log('registerSubmit ===>>', form, data)
            this.$EventBus.$emit('siteTrack', {
                ...data,
                gaPopScenario: this.options?.gaPopScenario,
                role: this.role,
                trackType: 'lead-register-submit',
                ele: this.$el
            });
        },
        registerSubmitSuccess(data = {}) {
            if (this.submitDisabled) {
                return; 
            }
            this.submitDisabled = true;
            this.formatData(data);
            return this.leadRegister();
        },
        registerSumbitError(errorInfo) {
            this.$EventBus.$emit('siteTrack', {
                gaPopScenario: this.options?.gaPopScenario,
                errorInfo,
                role: this.role,
                trackType: 'lead-register-submit-fail',
                ele: this.$el
            });
            this.trackGlobalRegisPopup(regState.fail);
        },
        trackGlobalRegisPopup(state) {
            this.onTrack && this.onTrack(this.regType.register, state);
        }
    },
    components: {
        'v-form': vForm,
        'v-input': vInput,
        checkbox
    }
};
